<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        v-on="on"
      >
        Import Attendance
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Attendance"
      text="Upload Attendance"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <helper-file-input
                v-model="file" 
                v-validate="'required'" 
                :max-size-in-mb="2"
                :max-number="1"
                data-vv-name="file"
                field-name="file"
                accept-type=".xlsx,.xls,.csv"    
                extension="ext:xlsx,xls,csv"         
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-row>
                    <v-col>
                      <v-btn                    
                        :disabled="progressing"
                        class="mx-2"    
                      >
                        Add file
                      </v-btn>
                      <span> 
                        {{ file ? '' : 'No file chosen' }}
                      </span>
                    </v-col>
                    <v-col
                      v-if="file"
                      cols="10"
                      class="px-2"
                    >
                      <span
                        v-for="(selectedFile, i) in file.selectedFiles"
                        :key="selectedFile.name"
                        class="font-weight-bold"
                      > {{ selectedFile.name }} {{ (i + 1) === file.selectedFiles.length ? '' : ',' }} </span>
                    </v-col>
                  </v-row>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1 caption">{{ errors.first('file') }}</span>
            </v-col>
          </v-row>

          <v-row v-if="successfullyImported">
            <v-col cols="12">
              <span
                style="color:green;font-size:15px;font-weight:900"
              >Successfully Imported Records: {{ importedRecords }}</span> 
            </v-col>

            <v-col cols="12">
              <span
                style="color:red;font-size:15px;font-weight:900"
              >Failed Records: {{ failedRecords }}</span> 
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              :class="{
                'overflow': failed.length>0,
              }"
              data-simplebar
            >
              <div
                v-for="(item,i) in failed"
                :key="i"
              >
                <span style="color:red">
                  There was an error on row <span class="font-weight-bold">{{ item.row }} </span>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"     
          @click="submitForm"
        >
          Import
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        file: null,
        successfullyImported: false, 
        importedRecords: 0,
        failedRecords: 0,
        failed: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
      },
    },
    methods: { 
      prepareFormData () {
        if (this.file) {
          return this.file.formData
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true 
    
            this.$api.attendances().import(this.prepareFormData())
              .then((res) => {
                this.$snack({ message: 'Import Succesfully' })
                this.failed = res.data.failed
                this.failedRecords = res.data.failed.length
                this.successfullyImported = true
                this.importedRecords = res.data.imported
                this.$emit('imported')

                this.$validator.reset()
                this.file = null

                this.progressing = false      
              })
              .catch((e) => {
                if (e.response.status === 409) {
                  this.$snack({ color: 'error', message: e.response.data.message })
                } else if (e.response.status === 500) {
                  this.$snack({ color: 'error', message: e.response.data.message })
                }
                this.progressing = false 
              })
          })
      },

      resetForm () {
        this.$validator.reset()
        this.file = null
        this.successfullyImported = false
      },
    },
  }
</script>

<style scoped>
  .overflow {
    height:45vh;
  }
</style>
